import React from 'react';
import {styled} from '@netx/core-components/Theme/styled';
import {type WithOwnerState} from '@netx/core-components/Theme/types';
import MuiAlert, {
	alertClasses,
	type AlertProps as MuiAlertProps,
} from '@mui/material/Alert';

const AlertRoot = styled(MuiAlert)(
	({theme, noWrap}: WithOwnerState<{}, AlertProps>) => ({
		display: 'flex',
		alignItems: 'center',
		[`& .${alertClasses.action}`]: {
			padding: theme.spacing(0, 0, 0, 2),
		},
		...(noWrap
			? {
					[`& .${alertClasses.message}`]: {
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
					},
				}
			: null),
	}),
);

export interface AlertProps extends MuiAlertProps {
	noWrap?: boolean;
}

export const AlertPrimitive = (
	props: AlertProps,
	ref: React.ForwardedRef<HTMLDivElement>,
) => <AlertRoot ref={ref} {...props} />;

export const Alert = React.forwardRef(AlertPrimitive) as (
	props: AlertProps,
) => JSX.Element;

export default Alert;
